/** Preserve authored meaning; layout owns visual truncation and exposes full text. */
export function formatQuadrantAxisLabel(rawLabel: string, _legacyFallbackToken?: string): string {
  return rawLabel.trim();
}
